import React, { useContext, useEffect, useState } from 'react';
import UserContext from '../../../contexts/UserContext';
import { Dimmer, Icon, Loader, Popup } from 'semantic-ui-react';
import sendToast from '../../../utils/Toast';
import { useHistory } from 'react-router-dom';
import StepOne from '../../components/ServiceOrderWidget/StepOne';
import StepTwo from '../../components/ServiceOrderWidget/StepTwo';
import StepThree from '../../components/ServiceOrderWidget/StepThree';
import useNeighborsPaymentAccess from '../../hooks/useNeighborsPaymentAccess';
import "./style.less";

export interface ServiceTypeConfig {
    Name: string;
    alternativeName: string;
    active: boolean;
}

const CreateOrder = () => {
    const [isFetching, setIsFetching] = useState(true);
    const [stepForm, setStepForm] = useState<number>(1);
    const [selectedServiceId, setSelectedServiceId] = useState<string>('');
    const [selectedServiceCategoryName, setSelectedServiceCategoryName] = useState<string>('');
    const [selectedServiceCategoryHeading, setSelectedServiceCategoryHeading] = useState<string>('');
    const history = useHistory();
    const {
        userObject: {
            registrants: { list: listOfResidents, activeRegistrantsIndexes },
        },
    } = useContext(UserContext);
    const activeResident = listOfResidents[activeRegistrantsIndexes[0]]; // get the first resident from the list of active residents because neighbors web only supports the resident who is logged in and we can't deselect or change it
    const { resolvedFacilityPaymentsEnabled } = useNeighborsPaymentAccess();

    useEffect(() => {
        checkValidation()
    }, [stepForm])

    const checkValidation = () => {
        const requirements = [
            { step: 2, field: selectedServiceCategoryName, fallback: 1, message: 'Service category is not selected' },
            { step: 3, field: selectedServiceCategoryName, fallback: 1, message: 'Service category is not selected' },
            { step: 3, field: selectedServiceId, fallback: 2, message: 'Service ID is not selected' },
        ];

        for (const rule of requirements) {
            if (stepForm === rule.step && !rule.field) {
                sendToast('warn', rule.message);
                setStepForm(rule.fallback);
                return;
            }
        }
    };

    const handleRedirectToOrderStatus = () => {
        if (stepForm === 1) {
            history.push({
                pathname: `/order-status`,
            });
        } else if (stepForm === 2) {
            setStepForm(1);
        } else if (stepForm === 3) {
            setStepForm(2);
        }
    };

    const getHeading = () => {
        if (stepForm === 1) {
            return 'Your Services';
        }
        if (stepForm === 2 || stepForm === 3) {
            const categoryHeading = selectedServiceCategoryHeading || selectedServiceCategoryName;
            return categoryHeading ? `Your Services - ${categoryHeading}` : 'Your Services';
        }
        return 'Your Services';
    };

    useEffect(() => {
        const heading = getHeading();
        if (heading) {
            window.dispatchEvent(
                new CustomEvent('orderStepChange', {
                    detail: heading,
                }),
            );
        }
    }, [stepForm, selectedServiceCategoryHeading, selectedServiceCategoryName]);

    const refreshHandler = () => {
        history.push({
            pathname: `/order-status`,
        });
    }

    return (
        <div>
            <Dimmer active={isFetching} inverted>
                <Loader>Loading</Loader>
            </Dimmer>
            <div className='headingContainer'>
                <Popup content='Go back to order status' trigger={
                    <Icon
                        name='arrow left'
                        size='large'
                        className='backIcon'
                        onClick={handleRedirectToOrderStatus}
                    />
                }
                />
            </div>
            <div className="wizard-steps-page">
                {[
                    { step: 1, label: 'Department' },
                    { step: 2, label: 'Service' },
                    { step: 3, label: 'Details' },
                ].map(({ step, label }, i) => (
                    <React.Fragment key={step}>
                        <div className={`wizard-step${stepForm === step ? ' active' : ''}${stepForm > step ? ' done' : ''}`}>
                            <div className="wizard-step-dot">
                                {stepForm > step ? (
                                    <Icon name="check" size="small" />
                                ) : step}
                            </div>
                            <div className="wizard-step-label">{label}</div>
                        </div>
                        {i < 2 && <div className="wizard-step-line" />}
                    </React.Fragment>
                ))}
            </div>
            <div className='divCenter'>
                <div className='orderServiceWidget' style={{ width: stepForm === 3 ? "60%" : "100%" }}>
                    {
                        stepForm === 1 && (
                            <StepOne
                                setSelectedServiceCategoryName={setSelectedServiceCategoryName}
                                setSelectedServiceCategoryHeading={setSelectedServiceCategoryHeading}
                                setIsFetching={setIsFetching}
                                setStepForm={setStepForm}
                                FacilityId={activeResident.Facility}
                            />
                        )
                    }
                    {
                        stepForm === 2 && (
                            <StepTwo
                                FacilityId={activeResident.Facility}
                                selectedServiceCategoryName={selectedServiceCategoryName}
                                selectedResidentId={activeResident._id}
                                residentId={activeResident._id}
                                setIsFetching={setIsFetching}
                                setStepForm={setStepForm}
                                setSelectedServiceId={setSelectedServiceId}
                                isFetching={isFetching}
                                facilityPaymentsEnabled={resolvedFacilityPaymentsEnabled}
                            />
                        )
                    }
                    {
                        stepForm === 3 && (
                            <StepThree
                                FacilityId={activeResident.Facility}
                                selectedServiceId={selectedServiceId}
                                setIsFetching={setIsFetching}
                                setStepForm={setStepForm}
                                selectedResidentId={activeResident._id}
                                selectedServiceCategoryName={selectedServiceCategoryName}
                                setSelectedServiceId={setSelectedServiceId}
                                setSelectedServiceCategoryName={setSelectedServiceCategoryName}
                                refreshHandler={refreshHandler}
                                isFetching={isFetching}
                                facilityPaymentsEnabled={resolvedFacilityPaymentsEnabled}
                            />
                        )
                    }
                </div>
            </div>
        </div>
    );
};

export default CreateOrder; 
